module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "table-container"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('el-col', {
    staticClass: "page-bar",
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "total-results"
  }, [_vm._v(" " + _vm._s(_vm.totalResult) + " ")]), _vm._v(" "), (_vm.list.length > 0) ? _c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "prev-text": "prev",
      "next-text": "next",
      "current-page": _vm.pagination.currentPage,
      "page-size": _vm.pagination.pageSize,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%",
      "cursor": "default"
    },
    attrs: {
      "data": _vm.currentList,
      "empty-text": "暫無資料"
    }
  }, [_c('el-table-column', {
    attrs: {
      "min-width": "30%",
      "prop": "date",
      "label": "申請日期",
      "formatter": _vm.formatDate
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "30%",
      "prop": "name",
      "label": "申請人"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "25%",
      "prop": "id",
      "label": "工號"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "15%",
      "prop": "status",
      "label": "狀態"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status === null) ? _c('div', [_c('div', [_vm._v("審核中")])]) : (scope.row.status === 1) ? _c('div', [_c('div', {
          staticStyle: {
            "color": "#008F05"
          }
        }, [_vm._v("通過")])]) : (scope.row.status === 0) ? _c('div', [_c('div', {
          staticStyle: {
            "color": "#D00000"
          }
        }, [_vm._v("不通過")])]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "page-bar",
    attrs: {
      "span": 24
    }
  }, [(_vm.list.length > 0) ? _c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "prev-text": "prev",
      "next-text": "next",
      "current-page": _vm.pagination.currentPage,
      "page-size": _vm.pagination.pageSize,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  }) : _vm._e()], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title row1"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../assets/icon/ic_soc.png"),
      "alt": "S"
    }
  }), _vm._v("\n                Group E-learning\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title row2"
  }, [_vm._v("\n                註冊申請狀態\n                "), _c('span', {
    staticClass: "sub-title"
  }, [_vm._v("(若對申請結果有疑問，可聯繫各部門管理員)")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0bee101e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/RegResult.vue
// module id = 894
// module chunks = 170